function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0567102,0,0,0.0567102,0.482181,0.482181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424,64L336,64L336,48C336,21.533 314.467,0 288,0L224,0C197.533,0 176,21.533 176,48L176,64L88,64C65.944,64 48,81.944 48,104L48,160C48,168.836 55.164,176 64,176L72.744,176L86.567,466.283C87.788,491.919 108.848,512 134.512,512L377.488,512C403.153,512 424.213,491.919 425.433,466.283L439.256,176L448,176C456.836,176 464,168.836 464,160L464,104C464,81.944 446.056,64 424,64ZM208,48C208,39.178 215.178,32 224,32L288,32C296.822,32 304,39.178 304,48L304,64L208,64L208,48ZM80,104C80,99.589 83.589,96 88,96L424,96C428.411,96 432,99.589 432,104L432,144L80,144L80,104ZM393.469,464.761C393.062,473.306 386.042,480 377.488,480L134.512,480C125.957,480 118.937,473.306 118.531,464.761L104.78,176L407.22,176L393.469,464.761Z",
    style: {
      fill: "rgb(214,0,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0585938,0,0,0.0585938,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,448C264.836,448 272,440.836 272,432L272,224C272,215.164 264.836,208 256,208C247.164,208 240,215.164 240,224L240,432C240,440.836 247.163,448 256,448ZM336,448C344.836,448 352,440.836 352,432L352,224C352,215.164 344.836,208 336,208C327.164,208 320,215.164 320,224L320,432C320,440.836 327.163,448 336,448ZM176,448C184.836,448 192,440.836 192,432L192,224C192,215.164 184.836,208 176,208C167.164,208 160,215.164 160,224L160,432C160,440.836 167.163,448 176,448Z",
    style: {
      fill: "rgb(214,0,0)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.f136287cbf5d6737151230a8d3331dfe.svg";
export { ForwardRef as ReactComponent };